module.exports = {
    mapLocale: {
      'en-GB': 'uk/en',
      de: 'de/de',
      'en-EG':'eg/en',
      'ar-EG':'eg/ar',
      'en-US':'us/en',
      'fr-FR':'fr',
      'pl':'pl',
      'es-US':'us/es',
      'en-AU': 'au/en'
    },
    mapLangSelector: {
      'en-GB': 'Great Britain (English)',
      de: 'Germany',
      'en-EG':'Egypt (English)',
      'ar-EG':'Egypt (Arabic)',
      'en-US':'United States (English)',
      'fr-FR':'France (French)',
      'pl':'Poland (Polish)',
      'es-US':'United States (Spanish)',
      'en-AU': 'Australia'
    },
    mapAddressCountry: {
      'en-GB': 'United Kingdom',
      de: 'Germany',
      'en-EG':'Egypt',
      'ar-EG':'Egypt',
      'en-US':'United States of America',
      'fr-FR':'France (French)',
      'pl':'Poland (Polish)',
      'es-US':'United States of America',
      'en-AU': 'Australia'
    },
    mapFetchifyCode: {
      'en-GB': 'GBR',
      de: 'DEU',
      'en-EG':'EGP',
      'ar-EG':'EGP',
      'en-US':'USD',
      'fr-FR':'EUR',
      'pl':'PLN',
      'es-US':'USD',
    },
    mapLinks: {
      Wellbeing: {
        'en-GB': 'wellbeing-articles',
        de: 'dein-wohlbefinden',
      },
      Recipes: {
        'en-GB': 'recipes',
        de: 'rezepte',
      },
      News: {
        'en-GB': 'news',
        de: 'news',
      },
    },
  }